import type { HTMLAttributes, ReactNode } from "react";
import "./Badge.css";

export type BadgeVariant =
  "neutral" | "accent" | "success" | "warning" | "danger";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  /** 12px leading glyph. Decorative — the label carries the meaning. */
  icon?: ReactNode;
  children: ReactNode;
}

export function Badge({
  variant = "neutral",
  icon,
  className,
  children,
  ...rest
}: BadgeProps) {
  const classes = ["fc-badge", `fc-badge--${variant}`, className]
    .filter((value): value is string => Boolean(value))
    .join(" ");

  return (
    <span {...rest} className={classes}>
      {icon !== undefined && icon !== null ? (
        <span className="fc-badge__icon" aria-hidden="true">
          {icon}
        </span>
      ) : null}
      {children}
    </span>
  );
}
